module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedit"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("In Memory of")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("Flight Sergeant Eric W. Spriggs, R.A.F. 1921-1944")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("Navigator of a Lancaster, 15 Squadron Bomber Command")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("Killed on active service, June 21, 1944.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a13f5d98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Dedi.vue
// module id = 60
// module chunks = 0